import styled from 'styled-components';

import { styledScroll } from 'styles/styledScroll';

import colors from 'themes/Main';

const { white, darkBlue, gray01, gray03 } = colors;

export const Container = styled.div`
  padding: 16px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
`;

export const Head = styled.p`
  margin-bottom: 16px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  color: ${darkBlue};
`;

export const Icon = styled.div`
  display: inline-block;
  margin-right: 4px;
`;

export const Certificates = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const CertificatesQuantity = styled.div`
  margin-right: 20px;
`;

export const Counter = styled.p`
  margin-bottom: 0;
  font-size: 34px;
  color: ${gray01};
  font-weight: 700;
  line-height: 48px;
`;

export const Description = styled.p`
  margin-bottom: 0px;
  color: ${gray03};
  font-size: 20px;
  line-height: 28px;
`;

export const CertificatesSlider = styled.div`
  ${styledScroll};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  overflow-x: auto;

  > div {
    &:not(:first-child) {
      margin-left: 32px;
    }

    &:last-child {
      margin-right: 32px;
    }
  }

  > div:not(:first-child) {
    margin-left: 32px;
  }
`;
